<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Checklist</v-toolbar-title>

      <v-spacer></v-spacer>

      <ChecklistFormDlg
        v-if="condominium_id"
        :dialog="formChecklistDialog"
        :openForm="() => openDialogForm()"
        :closeForm="() => closeDialogForm()"
        :editFormData="formData"
        :condominiumId="condominium_id"
      />
    </v-toolbar>

    <SearchCondominium @selectedCondominium="getAllChecklists" />

    <v-data-table
      :headers="headers"
      :items="tableData"
      rows-per-page-text="Linhas por página"
      no-data-text="Não há dados"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="error" v-if="props.item.status == 'STARTED'">start</v-icon>
            </template>
            <span>Iniciado</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="warning" v-if="props.item.status == 'OPENED'">launch</v-icon>
            </template>
            <span>Em andamento</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="success" v-if="props.item.status == 'FINISHED'">check_circle</v-icon>
            </template>
            <span>Concluído</span>
          </v-tooltip>
        </td>

        <td class="text-xs-left">
          <template v-if="props.item.start_date">
            {{ props.item.start_date | moment("DD/MM/YYYY") }}
          </template>
          <span v-else>--</span>
        </td>

        <td class="text-xs-left">
          <template v-if="props.item.end_date">
            {{ props.item.end_date | moment("DD/MM/YYYY") }}
          </template>
          <span v-else>--</span>
        </td>

        <td class="text-xs-center layout">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="permissions.edit"
                small
                class="mr-2"
                @click="editItem(props.item)"
                >edit</v-icon
              >
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="permissions.view"
                small
                class="mr-2"
                @click="editItem(props.item, 'viewForm')"
                >remove_red_eye</v-icon
              >
            </template>
            <span>Visualizar</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { getJobs } from '@/services/checklists'
import SearchCondominium from '@/components/checklists/SearchCondominium.vue'
import ChecklistFormDlg from '@/components/checklists/ChecklistFormDlg.vue'

export default {
  name: 'Checklists',

  components: {
    ChecklistFormDlg,
    SearchCondominium
  },

  data () {
    return {
      dialogShowPrepository: false,
      headers: [
        { text: 'Status', align: 'center', sortable: true, value: 'status' },
        { text: 'Data início', sortable: true, value: 'start_date' },
        { text: 'Data fim', sortable: true, value: 'end_date' },
        { text: 'Ações', sortable: false, align: 'left' }
      ],
      tableData: [],
      formChecklistDialog: false,
      formData: null,
      condominium_id: null
    }
  },

  computed: {
    permissions () {
      return this.$store.state.permissions.permissions.checklists
    },
  },

  methods: {
    async getAllChecklists (id) {
      this.condominium_id = id
      const response = await getJobs(id)

      this.tableData = response
    },

    resetDialog () {
      this.dialogShowPrepository = false
    },

    editItem (item, view) {
      view === 'viewForm' ? (item.view = true) : (item.view = false)
      item.condominium_id = this.condominium_id

      this.formData = Object.assign({}, item)
      this.formChecklistDialog = true
    },

    openDialogForm () {
      this.formData = null
      this.formChecklistDialog = true
    },

    closeDialogForm () {
      this.getAllChecklists(this.condominium_id)
      
      this.formChecklistDialog = false
    },
  },
}
</script>

<style>
</style>
